export enum EAttachmentsCategory {
  ALL = 'ALL',
  PITCH = 'PITCH',
  REQUEST = 'REQUEST',
  GROUP_REQUEST = 'GROUP_REQUEST',
  BRIEF = 'BRIEF',
  LICENSING = 'LICENSING',
  PARTIALLY_EXECUTED = 'PARTIALLY_EXECUTED',
  FULLY_EXECUTED = 'FULLY_EXECUTED',
  CUE_SHEET = 'CUE_SHEET',
  INVOICE = 'INVOICE',
  PAYMENT = 'PAYMENT',
  GENERAL = 'GENERAL',
  ATTACHMENTS = 'ATTACHMENTS'
}

export const uiAttachmentsCategories: { [key in EAttachmentsCategory]: string } = {
  [EAttachmentsCategory.ALL]: 'All',
  [EAttachmentsCategory.PITCH]: 'Playlist',
  [EAttachmentsCategory.BRIEF]: 'Pitch info',
  [EAttachmentsCategory.REQUEST]: 'Requests',
  [EAttachmentsCategory.GROUP_REQUEST]: 'Group Requests',
  [EAttachmentsCategory.LICENSING]: 'Licenses',
  [EAttachmentsCategory.INVOICE]: 'Invoices',
  [EAttachmentsCategory.PARTIALLY_EXECUTED]: 'Partially Executed Agreement',
  [EAttachmentsCategory.FULLY_EXECUTED]: 'Fully Executed Agreement',
  [EAttachmentsCategory.CUE_SHEET]: 'Cue Sheet',
  [EAttachmentsCategory.PAYMENT]: 'Payment',
  [EAttachmentsCategory.GENERAL]: 'General',
  [EAttachmentsCategory.ATTACHMENTS]: 'Attachments'
};
